<div [ngClass]="Theme">
    <ng-content select="[card-background]"></ng-content>
    <div class="wrapper-card">
        <ng-content select="[card-content]"></ng-content>
    </div>
</div>